module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "staff"
    }
  }, [_c('h2', [_vm._v(" Our team ")]), _vm._v(" "), _c('div', {
    staticClass: "staff"
  }, [_c('div', {
    staticClass: "presentation"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/fanny.jpg"),
      "alt": "Estéfania XARPELL, Vétérinaire"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Estéfania XARPELL")]), _vm._v(" "), _c('p', [_vm._v("Graduated from the Toulouse Veterinary School, CES of nutrition from the Maison Alfort veterinary school, DU of homeopathy from the Faculty of Medicine of Marseille.")])]), _vm._v(" "), _c('div', {
    staticClass: "presentation"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/ainhoa.jpg"),
      "alt": "Ainhoa XARPELL, Pharmacienne"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Ainhoa XARPELL")]), _vm._v(" "), _c('p', [_vm._v("Graduated from the University of Pharmacy of Barcelona (UB), engineer from the Higher School of Chemistry Electronic Physics of Lyon (CPE Lyon)")])]), _vm._v(" "), _c('div', {
    staticClass: "presentation"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/michel.jpg"),
      "alt": "Michel HEINZELMEIER, Relations client"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Michel HEINZELMEIER")]), _vm._v(" "), _c('p', [_vm._v("Engineer, CAAE of the IAE of Toulon")])]), _vm._v(" "), _c('div', {
    staticClass: "presentation"
  }, [_c('div', {
    staticClass: "imgF"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/frederique.jpg"),
      "alt": "Frédérique CHADERAT, Responsable informatique"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Frédérique CHADERAT")]), _vm._v(" "), _c('p', [_vm._v("Engineer. IT manager")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9d8771a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/En/Staff.vue
// module id = 151
// module chunks = 0